import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import { useNavigate } from "react-router-dom";

function EditSales() {
    
    const location = useLocation();
	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
    const navigate = useNavigate();

    const [productData, setProductData] = useState([]);
	const [qty, setQty] = useState(1);
	const [selectedProduct, setProduct] = useState('');
	const [notes, setNotes] = useState('');
	const [cartError, setCartError] = useState(false);
	const [error, setError] = useState('');
	const [cartItems, setCartItems] = useState([]);
	const [total, setTotal] = useState(0);
	const [gst, setGST] = useState(0);
	const [orderError, setOrderError] = useState(false);
	const [errorClient, setClientError] = useState('');
	const [advance, setAdvanve] = useState(0);
    const [orderId, setOrderId] = useState(null);
    const [orderData, setOrderData] = useState('');
    const [paymentStatus, setPaymentStatus] = useState(orderData[0]?.paymentStatus || "notPaid");

    
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    
    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);
    }, [location.search]);
    


    const getCart = () => {
		const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
		setCartItems(cartItems);

		let total = 0;
		cartItems.forEach(item => {
			total += Number(item.price) * Number(item.qty)
		});

		const productGst = (total - (total / (1 + 5 / 100)));

		setTotal(total);
		const gst = (Number(total)*18)/100;
		setGST(productGst);
	};

	function triggerError() {
		setCartError(true);
		setTimeout(() => {
			setCartError(false);
			setError('');
		}, 2000);
	}

	function triggerClientError() {
		setOrderError(true);
		setTimeout(() => {
			setOrderError(false);
			setClientError('');
		}, 2000);
	}


    const updateCart = () => {
        let total = 0;
		cartItems.forEach(item => {
			total += Number(item.price) * Number(item.qty)
		});

		const productGst = (total - (total / (1 + 5 / 100)));

		setTotal(total);
		const gst = (Number(total)*18)/100;
		setGST(productGst);
    };

    useEffect(() => {
        updateCart();
    }, [cartItems]);


	const getProducts = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/products/all-product/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
				setProductData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


    const getOrderDetails = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/sales/order-details/', {orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){

                setOrderData(response.data.data);

                let existingCartItems = [];

				response?.data?.data[0]?.orderData.forEach(item => {

                    const newItem = {
						product: item.code,
						qty: item.qty,
						price: item.price,
						name: item.Item
					};

					existingCartItems.push(newItem);
                })

                sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
				getCart();
                
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};




	useEffect(() => {
        if(orderId && orderId.length > 0){
            getOrderDetails();
        }
		getProducts();
		getCart();
        updateCart();
	},[orderId]);



	const changeQty = (e) => {
		const qtys = e.target.value;
		setQty(qtys);
	};



	const changeQtyBtn = (calc) => {
		if(calc === 'plus'){
			setQty(Number(qty)+1);
		}else{
			if(qty === 0){
				setQty(qty);
			}else{
				setQty(Number(qty)-1);
			}
		}
	};


	const addCart = () => {

		if(selectedProduct === '' || !selectedProduct){
			setError('Please select product');
			triggerError();
		}else{

			if(qty === 0 || !qty){
				setError('Please select quantity atleast 1');
				triggerError();
			}else{

				const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
				const existingItemIndex = existingCartItems.findIndex(item => item.product === selectedProduct);

				if (existingItemIndex !== -1) {
			
					const newQty = Number(existingCartItems[existingItemIndex].qty) + Number(qty);
					if (!isNaN(newQty) && newQty > 0) {
						existingCartItems[existingItemIndex].qty = newQty;
					} else {
						console.log("Invalid quantity");
					}
				}else{

					const product = productData.find((product) => product.id === selectedProduct);
					const price = product ? product.productPrice : null;
					const name = product ? product.productName : null;

					const newItem = {
						product: selectedProduct,
						qty: qty,
						price: price,
						name: name
					};

					existingCartItems.push(newItem);
				}

				sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
				getCart();
			}
		}
		setQty(0);
	};

	const removeItem = (id) => {
		const updatedCartItems = cartItems.filter(item => item.product !== id);
		sessionStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
		getCart();
	};

    const editQty = (product, qty) => {

        setCartItems(prevItems => {
            const updatedItems = prevItems.map(item => {
                if (item.product === product) {
                    return {
                        ...item,
                        qty: qty,
                    };
                }
                return item;
            });
            return updatedItems; 
            
        });
    };

    const editQtyBtn = (option, product) => {

        setCartItems(prevItems => {
            const updatedItems = prevItems.map(item => {
                if (item.product === product) {
                    return {
                        ...item,
                        qty: option === 'minus' ? parseInt(item.qty) - 1 : parseInt(item.qty) + 1,
                    };
                }
                return item;
            });
            
            return updatedItems; 
        });
    };
    

	const AddInvoice = async () => {

	  if(cartItems.length === 0){

		setClientError('Please add items!');
		triggerClientError();

	  }else{
			const sendData = {
				userId: userID,
                sellerId: orderData && orderData[0]?.sellerId,
                empId:orderData && orderData[0]?.empId,
                paymentStatus:orderData && orderData[0]?.paymentStatus,
                orderId: orderId,
                clientId: orderData && orderData[0]?.clientData.id,
				notes: notes,
				total: total,
                location: orderData && orderData[0]?.location,
				gst: gst,
                orderDate: orderData && orderData[0]?.orderDate,
                deliveryDate: orderData && orderData[0]?.deliveryDate,
                deliveredDate: orderData && orderData[0]?.deliveredDate,
				advance: advance,
				balance: Number(total - advance).toFixed(2),
				items: cartItems
			}
			
		  try {
			const response = await axios.post('https://api.trucoo.in/invoice/add-invoice/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
			
				alert('invoice updated');
				// window.location = 'logistic-orders';
                //navigate("/invoicepage", { state: { orderId } });
                // navigate("/viewsales", { state: { orderId } });
                navigate(`/account-view-orders?id=${orderId}`)


			}
		  } catch (error) {
			console.error(error);
		  }
	  }
	};

    const updatePayment = (status) => {
        setPaymentStatus(status);
    }

    // const updatePayment = async (paymentStatus) => {
    //     let newStatus = paymentStatus === 'notPaid' ? 'paid' : 'notPaid';
    
    //     const formDatas = {
    //         orderId: orderId,
    //         paymentStatus: newStatus
    //     };
    
    //     try {
    //         const response = await axios.post('https://api.trucoo.in/invoice/payment/', formDatas, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-API-KEY': 'erpTrucoo'
    //             }
    //         });
    
    //         if (response.data.status === 'success') {
    //             console.log("Successfully updated");
    
    //             // Navigate to invoice page after updating payment
    //             navigate("/invoicepage", { state: { orderId } });
    //         }
    //     } catch (error) {
    //         console.log("Error:", error.response || error.message);
    //     }
    // };
    

    const handleDownloadInvoice = () => {
        navigate("/invoicepage", { state: { orderId } });
    };


	//console.log(selectedClentData);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					
					<div class="row">
                       
						<div class="col-xxl-46 col-xl-4 col-lg-4 col-md-4 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Order {orderId}</h4>
								    <hr class="my-15" />

								    <div class="row">
								        <div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Select Product</label>
									            <select className="form-select" name="product" valu={selectedProduct} onChange={(e)=> setProduct(e.target.value)} required >
        											<option value="" hidden>Select Product</option>
													{productData?.map((product, index) => 
														<option value={product.id}>{product.productName}</option>
													)}
      											</select>
									        </div>
								        </div>
								        <div class="col-md-8">
									        <div class="form-group">
									            <label class="form-label">Quantity</label>
												<div class="input-group">
													<button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button>
									            	<input type="number" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
									        		<button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button>
												</div>
											</div>
								        </div>
										<div class="col-md-4 mt-4" align="right">
											{cartError && <p class="text-danger">{error}</p> }
											<button type="button" class="btn btn-primary" onClick={addCart}>Add Item</button>
										</div>


										<div class="col-md-6 mt-2">
											<label class="form-label">Advance Amount</label>
											<input type="number" class="form-control" value={advance} onChange={(e)=> {setAdvanve(e.target.value)}} />
										</div>

										<div class="col-md-6 mt-2">
											<label class="form-label">Balance Payment</label>
											<input type="text" disabled class="form-control" value={Number(total - advance).toFixed(2)}  />
										</div>

								    </div>
                                    <div class="form-group mt-2">
								        <label class="form-label">Notes</label>
								        <textarea rows="5" class="form-control" name="note" value={notes} onChange={(e)=> setNotes(e.target.value)} required></textarea>
								    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-12">
                            <div class="box">
                                <div class="box-body">
								    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Order Info</h4>
								    <hr class="my-15" />
                                    <div class="row">
									{cartItems.length > 0 ?
										<table class="table">
											<thead>
												<tr>
													<th>Product</th>
													<th width="30%">Qty</th>
													<th width="10%">Price</th>
													<th width="10%">Total</th>
													<th width="5%">Actions</th>
												</tr>
											</thead>
											<tbody>
												{cartItems?.map((product, index) => 
												<tr>
													<td>{product.name}</td>
													<td>
                                                        <div class="input-group">
													        <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {editQtyBtn('minus', product.product)}}>-</button>
									            	        <input type="text" class="form-control" style={{textAlign: 'center'}} name="phone" value={product.qty} onChange={(e) => editQty(product.product, e.target.value)}  />
									        		        <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {editQtyBtn('plus', product.product)}}>+</button>
												        </div>  
                                                    </td>
													<td>{Number(product.price).toFixed(2)}</td>
													<td>{(Number(product.price) * Number(product.qty)).toFixed(2)}</td>
													<td class="table-action min-w-100">
														<button class="form-control text-fade hover-primary" onClick={() => removeItem(product.product)}><i class="fa fa-trash"></i></button>
													</td>
												</tr>
												)}
												<tr>
													<td colspan="2"></td>
													<td colspan="2">Sub Total</td>
													<td style={{textAlign: 'right'}}>{Number(total-gst).toFixed(2)}</td>
												</tr>
												<tr>
													<td colspan="2"></td>
													<td colspan="2">Tax 5%</td>
													<td style={{textAlign: 'right'}}>{Number(gst).toFixed(2)}</td>
												</tr>
												<tr>
													<td colspan="2"></td>
													<th colspan="2">Grand Total</th>
													<th style={{textAlign: 'right'}}>{Number(total).toFixed(2)}</th>
												</tr>
											</tbody>
										</table>
										:
										<div align="center" class="mt-4 mb-4"> <p>Add Items</p></div>
										}
										<table class="table" width="100%">
											
											
                                            <tr>
												<td width="30%">Client</td>
												<td>{orderData && orderData[0]?.clientData.companyName}, {orderData && orderData[0]?.clientData.companyAddress} - {orderData && orderData[0]?.clientData.location} </td>
											</tr>

											<tr>
												<td width="30%">Delivery Date</td>
												<td>{orderData && orderData[0]?.deliveryDate} </td>
											</tr>

											{total > 0 &&
											<tr>
												<td width="30%">Order Value</td>
												<td>{Number(total).toFixed(2)}</td>
											</tr>
											}
											{advance > 0 && 
											<tr>
												<td width="30%">Advance Payment</td>
												<td>{Number(advance).toFixed(2)}</td>
											</tr>
											}
											{advance > 0 && 
											<tr>
												<td width="30%">Balance Payment</td>
												<td>{Number(total - advance).toFixed(2)}</td>
											</tr>
											}
										</table>
                                        {/* <div className="form-group mt-2">
                                             <label className="form-label">Update Payment Status</label>
                                                  <select 
                                                      className="form-select" 
                                                      onChange={(e) => updatePayment(e.target.value)}
                                                      value={paymentStatus}
                                                   >
                                                    <option value="notPaid">Not Paid</option>
                                                     <option value="paid">Paid</option>
                                                 </select>
                                  </div> */}
								    </div>
							    </div>
							</div>
						</div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12" align="center">
                            <div class="box">
                                <div class="box-body">
                                <button className="btn btn-primary w-150" onClick={AddInvoice} >Update Invoive</button>
							        {/* <div class="box-footer" align="center">
										{orderError && <p class="text-danger">{errorClient}</p>}
								        <button class="btn btn-primary" onClick={placeOrder} ><i class="fa fa-shopping-cart"></i> Confirm Delivery</button>
							        </div>   */}
                                    {/* {(userType === 'admin' || userType === 'account') ?
                                            orderData[0]?.paymentStatus === 'notPaid' ?
                                                <div className="col-lg-12 mt-4" align="center">
                                                    <button className="btn btn-success" onClick={() => updatePayment(orderData[0]?.paymentStatus)}>Mark As Paid</button>
                                                </div>
                                                :
                                                <div className="col-lg-12 mt-4" align="center">
                                                    
                                                    <button className="btn btn-success" onClick={handleDownloadInvoice}>View Invoice</button>
                                                    
                                                </div>
                                            :
                                            orderData[0]?.paymentStatus === 'paid' ? 
                                                <div className="col-lg-12 mt-4" align="center">
                                                    
                                                    <button className="btn btn-success" onClick={handleDownloadInvoice}>View Invoice</button>
                                                    
                                                </div>
                                                :
                                                <div className="col-lg-12 mt-4" align="center">
                                                    <button className="btn btn-secondary">Payment Pending</button>
                                                </div>
                                        }
						 */}      
                                    
					            </div>
						    </div>
						</div>
                     
					</div>
				
				</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default EditSales;